import { useQuery, useQueryClient } from "@tanstack/react-query";
import dayjs from "dayjs";
import { useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import useExamRoomActions from "../../../../api/hooks/admin/examRoom";
import SendMailModal from "./SendMailModal";
import useDebounceValue from "../../../../api/hooks/debounce";
import { getBankName } from "static";
import { isSendMailModalOpenState } from "recoil/admin/examRoom";
import { testRoomSnState } from "recoil/auth";
import Table from "../../../modules/layout/Table";
import Banner from "../../../modules/layout/Banner";
import { SERVER_IP } from "../../../../static/server";
import DeleteConfirmModal from "./DeleteConfirmModal";
// 관리자-시험실-신청자탭

const ApplicantTab = () => {
  const examRoomActions = useExamRoomActions();
  const setIsSendMailModalOpen = useSetRecoilState(isSendMailModalOpenState);
  const [mailUserSn, setMailUserSn] = useState(0);
  const [deleteUserSn, setDeleteUserSn] = useState(0);
  const [emailCheckData, setEmailCheckData] = useState();
  const [sendEmailAllBtnCheck, setSendEmailAllBtnCheck] = useState(true);
  const [mailSendCount, setMailSendCount] = useState(0);

  const sendEmail = async (receipt) => {
    const res = await examRoomActions.sendEmail({
      applicator_sn: receipt.sn,
    });

    setMailSendCount(mailSendCount + 1);

    // if (res) {
    //   setMailUserSn(receipt.sn);
    //   setIsSendMailModalOpen(true);
    // }
  };

  const sendEmailAll = async () => {
    if (sendEmailAllBtnCheck) {
      setSendEmailAllBtnCheck(false);
      const res = await examRoomActions.sendEmailAll({
        room_sn: isTestRoomSn,
      });

      alert("발송 요청 하셨습니다.");

      if (res) {
        setSendEmailAllBtnCheck(true);
        var emailFailedCnt = res?.data?.failedCnt;
        if (emailFailedCnt > 0) {
          alert("일괄발송 후 " + emailFailedCnt + "건 실패");
        }
      } else {
        setSendEmailAllBtnCheck(true);
      }
    }
    // else {
    // }
  };

  const sendMessage = async (params) => {
    const res = await examRoomActions.sendMessage();
  };

  // const getReceiptList = async () => {
  //   const res = await examRoomActions.getReceiptList();
  //   if (res) {
  //     setReceiptList(res?.data?.data);
  //     setReceiptInfo({ yet: res.data?.yet, total: res.data?.total });
  //   }
  // };

  const { getReceiptList } = useExamRoomActions();

  // const deleteReceipt = async (sn) => {
  //   const res = await examRoomActions.deleteReceipt({ sn });
  // };

  // Access the client
  const queryClient = useQueryClient();
  const isTestRoomSn = useRecoilValue(testRoomSnState);
  const [searchKeyword, setSearchKeyword] = useState("");
  const debouncedSearchKeyword = useDebounceValue(searchKeyword);

  const {
    data: receiptListData,
    refetch,
    isLoading,
  } = useQuery(
    ["getReceiptList", isTestRoomSn, debouncedSearchKeyword, mailSendCount],
    () =>
      getReceiptList({ room_sn: isTestRoomSn, keyword: debouncedSearchKeyword })
  );

  // console.log("receiptListData");
  // console.log(receiptListData);
  // console.log(receiptListData?.data);

  const { getRoomCnt } = useExamRoomActions();
  const { data: roomCnt } = useQuery({
    queryKey: ["getRoomCnt", isTestRoomSn],
    queryFn: () => getRoomCnt({ room_sn: isTestRoomSn }),
  });

  return (
    <div className="tab-content">
      <div
        className="tab-pane fade show active"
        id="content1"
        role="tabpanel"
        aria-labelledby="tab1"
      >
        <Banner
          properties={["코드발송 / 신청자"]}
          data={[`${roomCnt?.data?.mailsend}/${roomCnt?.data?.applicator}`]}
          icons={["test-ing"]}
        />

        <div className="flex filtering">
          <div>
            {/* <button className="btn-custom w-btn exel-icon-b">발송현황</button> */}
            <button
              className="btn-custom w-btn mail-icon-b"
              onClick={() => {
                sendEmailAll();
              }}
            >
              메일 일괄발송
            </button>
          </div>
          <div>
            <input
              type="text"
              className="search-input"
              placeholder="이름, 이메일"
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
            />
            {/* <button
              className="btn-custom b-btn input-btn"
              onClick={() => refetch()}
            >
              검색
            </button> */}
          </div>
        </div>
        <div className="tableFixHead table-responsive">
          <div className="overflow-scroll height-300">
            <Table
              isLoading={isLoading}
              className="roomtable-content1"
              header={[
                "No.",
                "이름",
                "발송현황(문자)",
                "발송현황(이메일)",
                "통장사본",
                "계좌정보",
                "작업",
              ]}
            >
              {receiptListData?.data?.map((receipt) => (
                <tr key={receipt.sn}>
                  <td>{receipt.sn}</td>
                  <td
                  // onClick={() => {
                  //   window.open(SERVER_IP + receipt.digital_sign_url);
                  // }}
                  >
                    {receipt.name}
                  </td>
                  {receipt.code_message_state === 1 && (
                    <td>
                      {receipt.code_message_sendtime}
                      <button
                        type="button"
                        className="message-modalbtn"
                        data-bs-toggle="modal"
                        data-bs-target="#message"
                      ></button>
                    </td>
                  )}
                  {receipt.code_message_state === 0 && (
                    <td>
                      <button className="send-btn msg-send-btn">
                        문자전송
                      </button>
                    </td>
                  )}
                  {receipt.code_email_state === 1 && (
                    <td>
                      {dayjs(receipt.code_email_sendtime).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )}
                      <button
                        type="button"
                        className="mail-modalbtn"
                        onClick={() => {
                          setMailUserSn(receipt.sn);
                          setTimeout(() => {
                            setMailUserSn(0);
                          }, 100);
                        }}
                      ></button>
                    </td>
                  )}
                  {receipt.code_email_state === 0 && (
                    <td>
                      <button
                        className="send-btn mail-send-btn"
                        onClick={() => sendEmail(receipt)}
                      >
                        메일전송
                      </button>
                    </td>
                  )}
                  {receipt.account_image_url && (
                    <td>
                      <a
                        href={SERVER_IP + receipt.account_image_url}
                        download={
                          receipt.name +
                          receipt.birthday_YMD +
                          "." +
                          receipt.account_image_url.split(".")[
                            receipt.account_image_url.split(".").length - 1
                          ]
                        }
                        target="_self"
                      >
                        <button type="button" className="bankbook"></button>
                      </a>
                    </td>
                  )}
                  {!receipt.account_image_url && <td>-</td>}
                  <td>
                    {receipt.account_name} / {getBankName(receipt.account_bank)}{" "}
                    /{receipt.account_num}
                  </td>
                  <td>
                    <button
                      className="trashbtn"
                      onClick={() => {
                        setDeleteUserSn(receipt.sn);
                      }}
                    ></button>
                  </td>
                </tr>
              ))}
              {receiptListData?.data.length === 0 && (
                <tr>
                  <td colSpan={7}>데이터가 없습니다.</td>
                </tr>
              )}
            </Table>
          </div>
        </div>
        <SendMailModal
          mailUserSn={mailUserSn}
          emailCheckData={emailCheckData}
        />
        <DeleteConfirmModal
          deleteUserSn={deleteUserSn}
          setDeleteUserSn={setDeleteUserSn}
        />
      </div>
    </div>
  );
};

export default ApplicantTab;
